var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatnotyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.3,
    height: 17.408,
    viewBox: "0 0 16.3 17.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2859",
    "data-name": "Group 2859",
    transform: "translate(0.49 0.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2744",
    "data-name": "Group 2744",
    transform: "translate(-0.49 -0.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_123",
    "data-name": "Union 123",
    d: "M13.527,17.24l-2.073-1.167-.22-.119-.071-.038c-.06-.031-.135-.071-.212-.115a8.137,8.137,0,0,1-2.8.493c-.266,0-.529-.012-.782-.036A8.148,8.148,0,1,1,16.3,8.149a8.066,8.066,0,0,1-1.656,4.927c.016.058.031.118.048.18l.012.047c.009.032.018.066.027.1,0,.015.009.033.014.052l.012.04.632,2.3a1.273,1.273,0,0,1-.214,1.109,1.3,1.3,0,0,1-1.018.507A1.277,1.277,0,0,1,13.527,17.24Zm-1.991-2.75c.1.058.224.126.326.178l.011.006c.112.059.2.108.283.153l1.759.99-.534-1.945-.042-.16-.012-.042c-.03-.115-.064-.245-.1-.355l-.17-.541.355-.443a6.7,6.7,0,0,0,1.4-5.118,6.527,6.527,0,0,0-1.184-2.973A6.715,6.715,0,0,0,8.147,1.429a7.024,7.024,0,0,0-.844.052A6.564,6.564,0,0,0,4.213,2.7,6.728,6.728,0,0,0,1.548,9.44a6.422,6.422,0,0,0,.972,2.394,6.931,6.931,0,0,0,2.461,2.245,6.757,6.757,0,0,0,5.616.333l.489-.192Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M9.072,16A1.252,1.252,0,1,1,7.82,17.252,1.252,1.252,0,0,1,9.072,16",
    transform: "translate(-4.197 -8.964)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M16.924,16a1.252,1.252,0,1,1-1.252,1.252A1.252,1.252,0,0,1,16.924,16",
    transform: "translate(-8.773 -8.964)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M24.776,16a1.252,1.252,0,1,1-1.252,1.252A1.252,1.252,0,0,1,24.776,16",
    transform: "translate(-13.349 -8.964)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatnotyicon);
export default __webpack_public_path__ + "static/media/chatnotyicon.6823ccf03d4e01940f5169fff3c5c1c9.svg";
export { ForwardRef as ReactComponent };